import React from 'react';
import PropTypes from 'prop-types';
import {RichText} from 'prismic-reactjs';

import {Box, Container, Grid, GridItem} from '@spothero/ui/';

import {
    bodySerializer,
    headingSerializer,
    getSliceThemeVariables,
    ignoreEmptyRichTextObjects,
} from 'cms/utils';
import {RICHTEXT_PROP_TYPES} from 'cms/proptypes';

const ContentSection = ({
    sectionId,
    sliceTheme = 'Light - Secondary',
    contentSliceTitle,
    contentSliceRichText,
    isMidFunnel,
}) => {
    const {textColor, backgroundColor} = getSliceThemeVariables(sliceTheme);

    return (
        <Box
            as="section"
            id={sectionId || null}
            data-testid="ContentSection"
            color={textColor}
            backgroundColor={backgroundColor}
            paddingY={isMidFunnel ? 0 : {base: 8, tablet: 16}}
            marginY={isMidFunnel ? {base: 8, desktop: 12} : 0}
        >
            <Container>
                <Grid>
                    <GridItem
                        colStart={{base: 0, desktop: 3}}
                        colSpan={{base: 12, desktop: 8}}
                    >
                        {ignoreEmptyRichTextObjects(contentSliceTitle)
                            .length ? (
                            <RichText
                                render={contentSliceTitle}
                                htmlSerializer={headingSerializer('h2', {
                                    marginBottom: {base: 6, tablet: 8},
                                    textAlign: 'center',
                                })}
                            />
                        ) : null}
                        <RichText
                            render={ignoreEmptyRichTextObjects(
                                contentSliceRichText
                            )}
                            htmlSerializer={bodySerializer()}
                        />
                    </GridItem>
                </Grid>
            </Container>
        </Box>
    );
};

/* eslint-disable camelcase */
ContentSection.propTypes = {
    contentSliceTitle: RICHTEXT_PROP_TYPES,
    contentSliceRichText: PropTypes.array,
    sectionId: PropTypes.string,
    sliceTheme: PropTypes.string,
    isMidFunnel: PropTypes.bool,
};

export default ContentSection;
